function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { matchPath } from 'react-router-dom';

/*
why you guys say google don't see helmet meta tags ,
I use https://search.google.com/search-console and see the helmet meta update the title

Use Google Search Console to see how Google crawls your site, and to initiate a crawl/index
of your pages: https://www.google.com/webmasters/tools/
*/

var ReactHelmet = function ReactHelmet(_ref) {
  var _page$metadata, _page$metadata$tags, _articleData, _articleData$tags;
  var pages = _ref.pages;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useState = useState({
      defaultTitle: '',
      defaultTags: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    page = _useState4[0],
    setPage = _useState4[1];
  useEffect(function () {
    var _defaultTags$metadata, _defaultTags$metadata2;
    var defaultTags = Object.values(pages).find(function (x) {
      return x.internalUrl === '/';
    });
    setState(_objectSpread(_objectSpread({}, state), {}, {
      defaultTitle: (defaultTags === null || defaultTags === void 0 ? void 0 : (_defaultTags$metadata = defaultTags.metadata) === null || _defaultTags$metadata === void 0 ? void 0 : _defaultTags$metadata.title) || '',
      defaultTags: (defaultTags === null || defaultTags === void 0 ? void 0 : (_defaultTags$metadata2 = defaultTags.metadata) === null || _defaultTags$metadata2 === void 0 ? void 0 : _defaultTags$metadata2.tags) || []
    }));
  }, [pages]);
  var defaultTitle = state.defaultTitle,
    defaultTags = state.defaultTags;
  useEffect(function () {
    setPage(Object.values(pages).find(function (x) {
      return x.internalUrl === pathname;
    }) || {});
  }, [pathname]);
  var getParams = function getParams(pathname) {
    var pathArr = pathname.split('/').filter(function (x) {
      return x.length > 0;
    });
    if (pathArr.length > 1) pathArr.splice(-1, 1);
    var matchProfile = matchPath({
      path: '/' + pathArr.join('/') + '/:articleID'
    }, pathname);
    return matchProfile && matchProfile.params || {};
  };
  var articleData = {};
  if (!('_id' in page)) {
    var _getParams = getParams(pathname),
      articleID = _getParams.articleID;
    if (articleID) {
      var pathArr = pathname.split('/').filter(function (x) {
        return x.length > 0;
      });
      if (pathArr.length > 1) pathArr.splice(-1, 1);
      var tmpPathname = pathArr.join('/');
      var tmpPage = Object.values(pages).find(function (x) {
        return x.internalUrl === '/' + tmpPathname;
      });
      if (tmpPage) {
        var _tmpPage$articles;
        (_tmpPage$articles = tmpPage.articles) === null || _tmpPage$articles === void 0 ? void 0 : _tmpPage$articles.forEach(function (x) {
          if (x.articleID.slug === articleID) articleData = x.articleID.metadata;
        });
      }
    }
  }
  var metaObj = {};
  defaultTags === null || defaultTags === void 0 ? void 0 : defaultTags.forEach(function (x) {
    metaObj[x.key + '' + x.value] = {
      key: x.key,
      value: x.value,
      content: x.content
    };
  });
  page === null || page === void 0 ? void 0 : (_page$metadata = page.metadata) === null || _page$metadata === void 0 ? void 0 : (_page$metadata$tags = _page$metadata.tags) === null || _page$metadata$tags === void 0 ? void 0 : _page$metadata$tags.forEach(function (x) {
    metaObj[x.key + '' + x.value] = {
      key: x.key,
      value: x.value,
      content: x.content
    };
  });
  (_articleData = articleData) === null || _articleData === void 0 ? void 0 : (_articleData$tags = _articleData.tags) === null || _articleData$tags === void 0 ? void 0 : _articleData$tags.forEach(function (x) {
    metaObj[x.key + '' + x.value] = {
      key: x.key,
      value: x.value,
      content: x.content
    };
  });
  var getTitle = function getTitle() {
    var _page$metadata2;
    if (!articleData) return '';
    if ('title' in articleData) return 'Posillico Materials - ' + articleData.title;
    return (page === null || page === void 0 ? void 0 : (_page$metadata2 = page.metadata) === null || _page$metadata2 === void 0 ? void 0 : _page$metadata2.title) || defaultTitle;
  };
  return /*#__PURE__*/React.createElement(Helmet, {
    title: getTitle(),
    meta: Object.values(metaObj).map(function (x) {
      return _defineProperty(_defineProperty({}, x.key, x.value), "content", x.content);
    })
  });
};
var mstp = function mstp(s) {
  return {
    pages: s.pages
  };
};
export default connect(mstp, null)(ReactHelmet);